import * as React from 'react';
import MQ from 'react-responsive';
import { MOBILE_MIN_WIDTH, TABLET_MIN_WIDTH } from '../utils';
const MediaQuery = ({ minWidth, maxWidth, children }) => {
    return (React.createElement(MQ, { values: { width: window.innerWidth }, minWidth: minWidth === 'mobile' ? +MOBILE_MIN_WIDTH + 1 : minWidth === 'tablet' ? +TABLET_MIN_WIDTH + 1 : null, maxWidth: maxWidth === 'mobile' ? MOBILE_MIN_WIDTH : maxWidth === 'tablet' ? TABLET_MIN_WIDTH : null }, children));
};
export default MediaQuery;
